import React from 'react'
import Tile from './tile'
import Figure from './figure'

const DrawTile = (tile, color, selectedSample, colorSchemeIndex, onSelectedSample ) => {
		return (
		<Tile 
			selected= {selectedSample === colorSchemeIndex}
			onSelectTile = {() => onSelectedSample(colorSchemeIndex, tile.colorScheme[colorSchemeIndex])}
		>
			{tile.paths.map(( path, pathIndex ) => {
				return <Figure key={pathIndex} transform={path.transform} d={path.d} fill={color[pathIndex]}/>
			})}
		</Tile>)
	}


const SampleMenu = ({ tile, selectedTileIndex, selectedSample, onSelectedSample }) => {
	return ( 
		<div>
		{tile.colorScheme.map( ( color, colorSchemeIndex) => {
					return DrawTile(tile,color, selectedSample, colorSchemeIndex, onSelectedSample);
		})}
	</div>)
}

export default SampleMenu


// WEBPACK FOOTER //
// ./src/components/mosaic/sampleMenu.jsx